import { render, staticRenderFns } from "./CompanyAwayDetailPage.vue?vue&type=template&id=d5ec72a6&scoped=true&"
import script from "./CompanyAwayDetailPage.vue?vue&type=script&lang=js&"
export * from "./CompanyAwayDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ec72a6",
  null
  
)

export default component.exports